module.exports = __webpack_public_path__ + "426d05021efefb65e5361d47bf1e59b2.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/paint-palette.png
// module id = 2699
// module chunks = 0